

import React, {useState, useRef, useEffect} from 'react';
import Player from 'react-player';
import Railway from '../components/Railway'

export default ({
  title,
  subtitle,
  description,
  playlist,
  sequences,
  routerProps: {
    location,
    history
  },
}) => {
  const [isPlayMode, setPlayMode] = useState(location.search.includes('mode=player'));
  
  const [searchTerm, setSearchTerm] = useState('');
  const [isPlaying, setPlaying] = useState(false)
  const player = useRef(null)
  const [seconds, setSeconds] = useState(undefined);

  const seekTo = seconds => {
    if (player && player.current && seconds !== undefined && !isNaN(seconds) && seconds >= 0) {
      player.current.seekTo(seconds, 'seconds')
      setPlaying(true);
      setPlayMode(true);
      if (!location.search.length) {
        history.push(location.pathname + '?mode=player')
      }
    }
  }

  useEffect(() => {
    const search = location.search.slice(1).split('&').reduce((res, exp) => {
      const parts = exp.split('=');
      return {
        ...res,
        [parts[0]]: parts[1]
      }
    }, {})
    if (search.mode === 'player' && !isPlayMode) {
      setPlayMode(true)
    } else if(!search.mode === 'player' && isPlayMode) {
      setPlayMode(false)
    }
    if (search.sequence && sequences[search.sequence]) {
      seekTo(sequences[search.sequence].beginT);
      history.push(location.pathname + '?mode=player')
    }
  }, [location]);
  const handleProgress = ({playedSeconds/*, played, loadedSeconds, loaded*/}) => {
    setSeconds(playedSeconds)
  }
  const onPlayFromStart = () => {
    const first = playlist[0].beginT;
    seekTo(first)
  }
  const goToPreview = () => {
    setPlaying(false);
    setPlayMode(false);
    history.push(location.pathname);
  }
  return (
    <>
      <main className="columns-container">
        <div className={`column content-container presentation-container ${isPlayMode ? '': 'active'}`}>
          <header>
            <h2>{title} - {subtitle}</h2>
          </header>
          <p>{description}</p>
        </div>
        <div className={`column content-container play-container ${isPlayMode ? 'active': ''}`}>
          <header>
            <h2  className="clickable" onClick={goToPreview}>{title} - {subtitle}</h2>
            <input 
              placeholder="Chercher dans les transcriptions"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </header>
          <ul>
          {
              playlist
              .filter(slug => {
                const item = sequences[slug];
                if (item) {
                  if (searchTerm.length) {
                    if (item.titlefr.toLowerCase().includes(searchTerm.toLowerCase())) {
                      return true
                    } else if (
                      item.transcripts.reduce((res, t) => `${res} ${t.contentfr}`, '')
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                    ) {
                      return true;
                    }
                    return false;
                  }
                  return true;
                }
                return false;
              })
              .map((slug, index) => {
                const item = sequences[slug];
                if (item) {
                  const isActive = seconds >= item.beginT && seconds <= item.endT;
                  const handleClick = () => {
                    seekTo(item.beginT)
                  }
                  return (
                    <li key={index}>
                      <h3 onClick={handleClick} className={`sequence-title ${isActive ? 'is-active': ''}`}>
                        <span>{item.titlefr}</span>
                      </h3>
                      <ul>
                        {
                          (item.transcripts || [])
                          .filter(transcript => {
                            if (searchTerm.length) {
                              return transcript.contentfr.toLowerCase().includes(searchTerm.toLowerCase())
                            }
                            return true;
                          })
                          .map((transcript, index2) => {
                            const {contentfr} = transcript;
                            const isActive = seconds >= transcript.begin && seconds  <= transcript.end;
                            const handleTranscriptClick = () => {
                              seekTo(transcript.begin);
                            }
                            return (
                              <li className={`chunk ${isActive ? 'is-active': ''}`} onClick={handleTranscriptClick} key={index2}>
                                {contentfr}
                              </li>
                            )
                          })
                        }
                      </ul>
                    </li>
                  );
                }
                return null;
              })
            }
          </ul>

        </div>
      </main>
      <aside className="columns-container">
        <div className={`overview-container content-container column ${isPlayMode ? '' : 'active'}`}>
          <h3 className="clickable" onClick={onPlayFromStart}>{title} - voir les morceaux choisis</h3>
          <ul>
            {
              playlist.map((slug, index) => {
                const item = sequences[slug];
                if (item) {
                  const handleClick = () => {
                    seekTo(item.beginT)
                  }
                  return (
                    <li className="sequence-tile" onClick={handleClick} key={index}>
                      {item.titlefr}
                    </li>
                  );
                }
                return null;
              })
            }
          </ul>
        </div>
        <div className={`player-container column ${isPlayMode ? 'active' : ''}`}>
          <Player 
            ref={player} 
            onProgress={handleProgress} 
            controls 
            loop 
            url="https://player.vimeo.com/video/114275030?title=0&portrait=0&badge=0&autoplay=1&app_id=122963" 
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
            onEnded={() => setPlaying(false)}
            playing={isPlaying}
          />
        </div>
      </aside>

      <Railway
        playlist={playlist}
        sequences={sequences}
        seekTo={seekTo}
        seconds={seconds}
        visible={isPlayMode}
      />
    </>
  )
}